import adsTracker from 'bundles/event-tracking/lib';

import type { Maybe } from './__generated__/baseContentfulTypes';

export const trackApplyClick = (
  slug: string,
  productId: string | undefined,
  productName: string | undefined,
  productCategory: Maybe<string> | undefined
) => adsTracker.trackDegreeApplyNow(slug, productId, productName, productCategory);

export const trackEmailMeInfoClick = (
  slug: string,
  productId: string | undefined,
  productName: string | undefined,
  productCategory: Maybe<string> | undefined
) => adsTracker.trackEmailMeInfo(slug, productId, productName, productCategory);
